import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getProfessionalInformationDataRequest: ['response'],
    getProfessionalInformationDataSuccess: ['response', 'loading'],
    getProfessionalInformationDataFailure: ['error'],
})

export const getProfessionalInformationDataTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getProfessionalInformationDataSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getProfessionalInformationDataFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getProfessionalInformationDataRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_PROFESSIONAL_INFORMATION_DATA_REQUEST]: getProfessionalInformationDataRequest,
    [Types.GET_PROFESSIONAL_INFORMATION_DATA_SUCCESS]: getProfessionalInformationDataSuccess,
    [Types.GET_PROFESSIONAL_INFORMATION_DATA_FAILURE]: getProfessionalInformationDataFailure,
})
